var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26954 4.83041L0.623641 5.53539L0.541355 5.55292C0.416789 5.58753 0.303231 5.65612 0.212277 5.75169C0.121323 5.84726 0.0562326 5.96637 0.0236521 6.09688C-0.00892837 6.22739 -0.00783137 6.36461 0.026831 6.49452C0.0614934 6.62444 0.128479 6.7424 0.220948 6.83636L3.58667 10.2652L2.79294 15.1086L2.78347 15.1925C2.77585 15.3273 2.8026 15.4618 2.86099 15.5823C2.91938 15.7028 3.00731 15.8048 3.11577 15.878C3.22424 15.9512 3.34935 15.9929 3.47828 15.9989C3.60721 16.0048 3.73534 15.9748 3.84955 15.9119L8.00464 13.6255L12.1503 15.9119L12.2231 15.947C12.3433 15.9965 12.4739 16.0117 12.6016 15.991C12.7292 15.9703 12.8493 15.9144 12.9495 15.829C13.0497 15.7437 13.1265 15.632 13.1718 15.5054C13.2172 15.3788 13.2295 15.2419 13.2076 15.1086L12.4131 10.2652L15.7803 6.8356L15.8371 6.77082C15.9183 6.66623 15.9715 6.541 15.9913 6.40789C16.0111 6.27477 15.9969 6.13853 15.9501 6.01305C15.9032 5.88756 15.8254 5.77732 15.7246 5.69355C15.6238 5.60977 15.5036 5.55547 15.3762 5.53615L10.7303 4.83041L8.65347 0.42525C8.59337 0.297618 8.50034 0.190142 8.3849 0.114987C8.26946 0.039832 8.13622 0 8.00027 0C7.86432 0 7.73109 0.039832 7.61565 0.114987C7.50021 0.190142 7.40718 0.297618 7.34708 0.42525L5.26954 4.83041Z",
    fill: "#FFBE40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9badb77bd405692be558294e784e5210.svg";
export { ForwardRef as ReactComponent };